/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { TabBarBodyLayout } from '@veeam-vspc/shared/components';

import { VirtualInfrastructure } from './components';

export const BackupJobsVirtualInfrastructurePage: React.FC<{}> = () => (
    <TabBarBodyLayout>
        <VirtualInfrastructure />
    </TabBarBodyLayout>
);
